export default __webpack_public_path__ + "static/media/fruitFilledBiscuits.aae653f1.jpg";